import React, { Component } from 'react';
import { DragHandle as DragHandleIcon } from '@material-ui/icons'
import { SortableHandle, SortableElement, SortableContainer } from 'react-sortable-hoc';
import { ListItemIcon, ListItem, ListItemText, ListItemSecondaryAction, IconButton, Icon, List, Typography, ListItemAvatar, Button, Popover } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';

import questionsService from '../../api/questionsService';
import { selectQuestion, cleanSelectedQuestion } from '../../redux/actions/questionsActions';

const mapStateToProps = ({ questionState }) => ({
    questions: questionState.questions,
    selectedQuestion: questionState.selectedQuestion
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ selectQuestion, cleanSelectedQuestion }, dispatch)
);


class QuestionsList extends Component {
    render() {
        const questionsSort = this.props.questions.map((question) => ({ id: question.id, text: question.query, order: question.ordenation }));
        if (this.props.questions.length > 0) {
            return (
                <SortableListContainer
                    items={questionsSort}
                    useDragHandle={true}
                    onSortEnd={(obj) => {
                        const { oldIndex, newIndex } = obj;                        
                        questionsService.changeQuestionOrder(oldIndex, newIndex);
                    }}
                    showModal={this.props.showModal}
                    lockAxis="y"
                />
            );
        } else {
            return (
                <Typography variant="body1">There's no questions registered yet.</Typography>
            )
        }

    }
}

const DragHandle = SortableHandle(() => (
    <ListItemIcon>
        <DragHandleIcon />
    </ListItemIcon>
));

const SortableItem = connect(null, mapDispatchToProps)(SortableElement(({ id, text, order, showModal, selectQuestion }) => (
    <ListItem ContainerComponent="div">
        <ListItemAvatar>
            <DragHandle />
        </ListItemAvatar>
        <ListItemText primary={`#${order}   ${text}`} />
        <ListItemSecondaryAction>
            <ListItemIcon>
                <IconButton onClick={() => {
                    selectQuestion({
                        id,
                        query: text,
                        ordenation: order,
                    });
                    showModal();
                }}>
                    <Icon>edit</Icon>
                </IconButton>
            </ListItemIcon>
            <PopupState variant="popover" popupId="demo-popup-popover">
                {popupState => {
                    const bindPopoverProperties = bindPopover(popupState);
                    return (
                        <ListItemIcon>
                            <IconButton {...bindTrigger(popupState)}>
                                <Icon>delete</Icon>
                            </IconButton>
                            <Popover
                                {...bindPopoverProperties}

                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                            >
                                <div style={{ padding: 25 }}>
                                    <Typography>Do you really want to delete this question? <br /> This action can't be undone.</Typography>

                                    <div style={{ width: '100%', textAlign: 'right', marginTop: 10 }}>
                                        <Button variant="text" color="primary" style={{ marginRight: 10 }} onClick={() => {
                                            bindPopoverProperties.onClose();
                                        }}>Cancel</Button>
                                        <Button variant="contained" color="secondary" onClick={() => {
                                            questionsService.deleteQuestion(id);
                                        }}>Delete</Button>
                                    </div>
                                </div>
                            </Popover>
                        </ListItemIcon>
                    )
                }}
            </PopupState>
        </ListItemSecondaryAction>
    </ListItem>
)));

const SortableListContainer = SortableContainer(({ items, showModal }) => (
    <List component="div">
        {items.map(({ id, text }, index) => (
            <SortableItem key={id} id={id} index={index} text={text} order={index + 1} showModal={showModal} />
        ))}
    </List>
));



export default connect(mapStateToProps)(QuestionsList);